module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABWklEQVQ4T82Uv0rDUBTGvy8puosOUkVN6ugzaCXB4OYgCIKjBR/AVZwcfANBcHFwcyrSBNpdKrgIQpt0cHJwt9gcCSE0gSS9lQ7e6XLvub9zvvPnEjNezOOJu74zjR/ag05inwFK26xhJC8Q6aoDuQxgCGpHtHpvWaBnNAE+0urfqADFMx2INABsgXJFK7jNAl1DgLCellAGFte4AFiFyCKIV9r+5QyAY5eFQEDbBqS0MLSDehxhYsdOMZCVT0h4WCY3ehwDgWifX+U/5VABCOESiLNMhDqvues302fKEWJe3vGtn6Yfp2Ul58rA6dpGQfL/A44/A60dTYrK2EUqCnOYbVAVHJ5pB+fFQM84hnCPdv9kEk5a5gGIBu2+I97GHUCXln+faWx5WlmAPvcAogaRwSQowFWAXUDWMBru0/n4yp+UlrEJhtX4sgLgp5Sd1w25P/bkCIstfgHoiMIVJOJSbwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/twoliterature1.png
// module id = Opjo
// module chunks = 18